import { render, staticRenderFns } from "./NonconformitiesListFilters.vue?vue&type=template&id=a2ff83da&"
import script from "./NonconformitiesListFilters.vue?vue&type=script&lang=js&"
export * from "./NonconformitiesListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports